export const APP_CONSTANTS = {
    REPORT_DISPLAY_TIME: 60000, // 60 seconds (1 minute)
  };
  